import tinycolor from 'tinycolor2';

var Element = require('./abstract/element');
var TextGetter = require('./text');

module.exports = Shape;

function Shape () {}
Shape.prototype = new Element();
Shape.prototype.constructor = Shape;

Shape.prototype.initialize = function () {
  Element.prototype.initialize.call(this);

  this.structure = _.extend(this.structure, {
    'type': null,
    'fill': {
      'color': null,
      'colorGroup': null
    },
    'stroke': {
      'color': null,
      'width': null,
      'dasharray': null,
      'linejoin': null,
      'linecap': null
    }
  });
};

Shape.prototype.getType = function () {
  return this.element.nodeName;
};

Shape.prototype.getFillColor = function (element) {
  element = _.isElement(element) ? element : this.element;
  const color = tinycolor(element.getAttribute('fill'));
  const isValidColor = color.isValid() && color.getAlpha();
  const isInvalidGroup = element.tagName === 'g' && !element.querySelector(':not([fill])');

  if (!isValidColor) return null;
  if (isInvalidGroup) return null;

  return color.toString();
};

Shape.prototype.getFillColorGroup = function (element) {
  return (element && element.nodeType === 1
    ? element
    : this.element
  ).dataset.colorGroup;
};

Shape.prototype.getStrokeColor = function () {
  if (!this.element.getAttribute('stroke') && !this.element.getAttribute('stroke-width')) {
    return;
  }

  var color = tinycolor(this.element.getAttribute('stroke') || '#000');
  if (!color.isValid() || !color.getAlpha()) return;

  return color.toString();
};

Shape.prototype.getStrokeWidth = function () {
  if (!this.element.getAttribute('stroke')) return;
  return parseFloat(this.element.getAttribute('stroke-width')) || 1;
};

Shape.prototype.getStrokeDasharray = function () {
  return this.element.getAttribute('stroke-dasharray');
};

Shape.prototype.getStrokeLinejoin = function () {
  return this.element.getAttribute('stroke-linejoin');
};

Shape.prototype.getStrokeLinecap = function () {
  return this.element.getAttribute('stroke-linecap');
};

Shape.prototype.getSizeWidth = function () {
  var width = Element.prototype.getSizeWidth.call(this);
  if (!width && this.element.nodeName === 'line') {
    return this.getStrokeWidth();
  }

  return width;
};

Shape.prototype.getSizeHeight = function () {
  var height = Element.prototype.getSizeHeight.call(this);
  if (!height && this.element.nodeName === 'line') {
    return this.getStrokeWidth();
  }

  return height;
};
